//转换时间格式如: 2025-06-03T14:41:05+08:00 转换成 2025-06-03 14:41:05
export function transTime(time){
  const dt = new Date(time)
  // 手动格式化为 YYYY-MM-DD HH:MM:SS
  const year = dt.getFullYear()
  const month = String(dt.getMonth() + 1).padStart(2, '0')
  const day = String(dt.getDate()).padStart(2, '0')
  const hours = String(dt.getHours()).padStart(2, '0')
  const minutes = String(dt.getMinutes()).padStart(2, '0')
  const seconds = String(dt.getSeconds()).padStart(2, '0')
  const formattedTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
  return formattedTime
}
